import { render } from "./AgroShopOnboarding.vue?vue&type=template&id=de29aa1c&scoped=true"
import script from "./AgroShopOnboarding.vue?vue&type=script&lang=js"
export * from "./AgroShopOnboarding.vue?vue&type=script&lang=js"

import "./AgroShopOnboarding.vue?vue&type=style&index=0&id=de29aa1c&lang=css"
import "./AgroShopOnboarding.vue?vue&type=style&index=1&id=de29aa1c&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de29aa1c"]])

export default __exports__